import request from '@/utils/request'

export function getInvoiceList(data) {
  return request.post('/wxfwh/invoice-list', data)
}

export function addInvoice(data) {
  return request.post('/wxfwh/invoice-add', data)
}

export function modifyInvoice(data) {
  return request.post('/wxfwh/invoice-modify', data)
}

export function deleteInvoice(data) {
  return request.post('/wxfwh/invoice-delete', data)
}

export function addInvoiceDetail(data) {
  return request.post('/wxfwh/invoice-detail-add', data)
}

export function modifyInvoiceDetail(data) {
  return request.post('/wxfwh/invoice-detail-modify', data)
}

export function deleteInvoiceDetail(data) {
  return request.post('/wxfwh/invoice-detail-delete', data)
}



// WEBPACK FOOTER //
// ./src/api/invoice.js